let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("65oBn")).then(() => parcelRequire('42GPN'));